import React, { Component, Fragment } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';

import theme from '../../config/theme';
import Chat from '../Chat/Chat';
import Header from '../Header/Header';
import Portfolio from '../Portfolio/Portfolio';

class App extends Component {
  render() {
    return (
      <Fragment>
        <CssBaseline />
        <MuiThemeProvider theme={ theme }>
          <Header />
          <main className="content">
            <Switch>
              <Redirect exact from='/' to='/portfolio' />
              <Route path='/portfolio' exact component={ Portfolio } />
              <Route path='/chat' exact component={ Chat } />
            </Switch>
          </main>
        </MuiThemeProvider>
      </Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js